import React from 'react'
import { isIos } from 'lib'
import { input } from './CustomInput.css'
import classNames from 'classnames'

type Props = React.InputHTMLAttributes<HTMLInputElement>

export const CustomInput = ({ className, autoFocus, ...rest }: Props) => {
	const autofocus = isIos() ? undefined : autoFocus
	return <input className={classNames(input, className)} {...rest} autoFocus={autofocus} />
}
